import TeamsList from './TeamsList'
import './style.styl'

const TeamsMangementSettings = () => <TeamsList />

export default TeamsMangementSettings



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/component.js